import {
  TKwikUICheckboxContentAlign,
  TKwikUICheckboxSize,
  VKwikUICheckboxContentAlign,
  VKwikUICheckboxSize
} from "./checkbox.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    contentAlign: (x: TKwikUICheckboxContentAlign) =>
      VKwikUICheckboxContentAlign.includes(x),
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    placeholder: isString,
    size: (x: TKwikUICheckboxSize) => VKwikUICheckboxSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
